<template>
  <div class="product-detail-reviews">
    <fn-section
      v-if="reviewsScript"
      id="reviews"
      constrained="l"
      padding-top="s"
      padding-bottom="s"
    >
      <div
        v-if="reviews.loading"
        class="loading-reviews"
      >
        <fn-loading-overlay />
        <fn-headline
          type="h2"
          size="h3"
        >
          {{ $t('product.reviews.loading') }}
        </fn-headline>
      </div>

      <div v-if="reviews.error">
        <fn-headline type="h3">
          {{ $t('product.reviews.error') }}
        </fn-headline>
      </div>

      <div
        v-if="product"
        id="pdpReviewContainer"
        data-bv-show="reviews"
        :data-bv-product-id="product.code"
      />

      <div
        v-if="product"
        id="pdpQuestionsContainer"
        data-bv-show="questions"
        :data-bv-product-id="product.code"
      />
    </fn-section>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  product: Record<string, any>;
  reviewsScript: string;
}>();

const reviews = reactive({
  loading: true,
  error: false,
});

if (props.reviewsScript) {
  useHead({
    script: [
      {
        key: 'bazaarvoice',
        src: props.reviewsScript,
        async: true,
        type: 'text/javascript',
        onerror: () => {
          reviews.error = true;
        },
        onload: () => {
          reviews.loading = false;
        },
      },
    ],
  });
}

onMounted(() => {
  if ('BV' in window && typeof window.BV === 'object') {
    reviews.loading = false;
  }
});
</script>

<style lang="scss" scoped>
.loading-reviews {
  position: relative;
  height: 200px;
}
</style>
